// Shared Google Place `address_components` parsing, used by every feature that
// turns a selected Places suggestion into address fields (operational address
// map pin, Legal section autofill). Spain's province sits at
// administrative_area_level_2 (level_1 is the Autonomous Community), so it
// needs its own branch; every other supported country uses level_1 directly.
export const parseGooglePlaceAddress = (place) => {
  const components = place?.address_components || [];

  const get = (type) =>
    components.find((c) => c.types.includes(type))?.long_name || '';
  const getShort = (type) =>
    components.find((c) => c.types.includes(type))?.short_name || '';

  const country = getShort('country');
  const state =
    country === 'ES'
      ? get('administrative_area_level_2') || get('administrative_area_level_1')
      : getShort('administrative_area_level_1');
  // Long-form province name (e.g. "Noord-Holland" instead of "NH"), kept
  // separate from `state` so existing consumers of the short form (the
  // operational address, which stores it as free text) are unaffected.
  // Callers that need to match against a province name list should use this.
  const stateLong =
    country === 'ES' ? state : get('administrative_area_level_1');
  // Only treat the Places `name` as a business/legal name when the result is
  // an establishment - a plain street address's `name` is just the address
  // itself and would otherwise leak into a "legal name" field.
  const businessName = place?.types?.includes('establishment')
    ? place?.name || ''
    : '';

  return {
    line1:
      `${get('street_number')} ${get('route')}`.trim() ||
      (place?.formatted_address
        ? place.formatted_address.split(',')[0].trim()
        : ''),
    line2: get('subpremise'),
    city:
      get('locality') ||
      get('postal_town') ||
      get('administrative_area_level_2'),
    state,
    stateLong,
    postalCode: get('postal_code'),
    country,
    businessName,
  };
};
